import { render, staticRenderFns } from "./WindRoseChart.vue?vue&type=template&id=23472d0c"
import script from "./WindRoseChart.vue?vue&type=script&lang=ts"
export * from "./WindRoseChart.vue?vue&type=script&lang=ts"
import style0 from "./WindRoseChart.vue?vue&type=style&index=0&id=23472d0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports